import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import SearchPatientAnalysis from "../../../Classes/Models/Requests/Accounting/SearchPatientAnalysis";
import { LanguageContext } from "App";
import { daysOfWeek } from "../../../layouts/Services/constants";
const PatientAnalyticsSearch = ({ setSearchReq }) => {
  let req = new SearchPatientAnalysis();

  const [Id, setId] = useState();
  const [UserName, setUserName] = useState();
  const [TotalSessions, setTotalSessions] = useState();
  const [Admitted, setAdmitted] = useState();
  const [Appointments, setAppointments] = useState();
  const [Exceptions, setExceptions] = useState();
  const [sortBy, setSortBy] = useState();
  const [sortOrder, setSortOrder] = useState();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedDays, setSelectedDays] = useState([]);
  const [enableDaysFilter, setEnableDaysFilter] = useState(false);

  const { translations } = useContext(LanguageContext);

  const handleDayChange = (dayValue) => {
    setSelectedDays((prev) =>
      prev.includes(dayValue)
        ? prev.filter((d) => d !== dayValue)
        : [...prev, dayValue],
    );
  };

  const onSearchClick = async () => {
    req.id = Id;
    req.name = UserName;
    req.sessionsCount = TotalSessions;
    req.admittedSessionsCount = Admitted;
    req.appointmentSessionsCount = Appointments;
    req.exceptionCount = Exceptions;
    req.sortBy = sortBy;
    req.sortOrder = sortOrder;
    req.fromDate = fromDate;
    req.toDate = toDate;
    req.selectedDays = enableDaysFilter ? selectedDays : [];

    setSearchReq(req);
  };

  useEffect(() => {
    onSearchClick();
  }, [sortBy, sortOrder]);

  return (
    <Card sx={{ padding: "1em" }}>
      <MDBox
        pt={2}
        px={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MDTypography variant="h6" fontWeight="medium">
          {translations.SearchPatientAnalytics}
        </MDTypography>
        <div>
          <MDButton
            type="button"
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
            }}
            color="text"
            onClick={() => onSearchClick()}
          >
            {translations.SearchPatientAnalyticsSearch}
          </MDButton>
        </div>
      </MDBox>
      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <div className="container-fluid mt-4">
          <div className="row">
            <div className="col-md-4 mt-3">
              <MDInput
                label={translations.SearchPatientAnalyticsUserId}
                onChange={(e) => setId(e.target.value)}
                type="number"
                fullWidth
              />
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                label={translations.SearchPatientAnalyticsUserName}
                onChange={(e) => setUserName(e.target.value)}
                fullWidth
              />
            </div>
            <div className="col-md-2 mt-3">
              <MDInput
                label={translations.FromDate || "From Date"}
                type="date"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setFromDate(e.target.value)}
                fullWidth
              />
            </div>
            <div className="col-md-2 mt-3">
              <MDInput
                label={translations.ToDate || "To Date"}
                type="date"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setToDate(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                label={translations.SearchPatientAnalyticsTotalSessions}
                onChange={(e) => setTotalSessions(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                label={translations.SearchPatientAnalyticsAppointments}
                onChange={(e) => setAppointments(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                label={translations.SearchPatientAnalyticsAdmitted}
                onChange={(e) => setAdmitted(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsExceptions}
                onChange={(e) => setExceptions(e.target.value)}
                type="number"
                fullWidth
              />
            </div>
          </div>

          <hr className="mt-4" />

          <MDBox display="flex" alignItems="center" mb={1}>
            <MDTypography variant="button" fontWeight="bold" color="text">
              {"Select Days of Week"}
            </MDTypography>
            <Switch
              checked={enableDaysFilter}
              onChange={(e) => {
                setEnableDaysFilter(e.target.checked);
                if (!e.target.checked) setSelectedDays([]);
              }}
            />
          </MDBox>

          {enableDaysFilter && (
            <MDBox display="flex" flexWrap="wrap">
              <FormGroup row>
                {daysOfWeek.map((day) => (
                  <FormControlLabel
                    key={day.value}
                    control={
                      <Checkbox
                        checked={selectedDays.includes(day.value)}
                        onChange={() => handleDayChange(day.value)}
                        color="primary"
                      />
                    }
                    label={
                      <MDTypography variant="caption" fontWeight="regular">
                        {translations[day.label] || day.label}
                      </MDTypography>
                    }
                    sx={{ marginRight: "15px" }}
                  />
                ))}
              </FormGroup>
            </MDBox>
          )}
        </div>
      </div>
    </Card>
  );
};

export default PatientAnalyticsSearch;
